import React from 'react'
import { Typography, Col, Form, Input, Button, Select, Spin } from 'antd'

import './bubbleMap.css'
import './halfMap.css'

const { Paragraph } = Typography
const { Option } = Select

class EQTLviz extends React.Component {
    state = {
        disabled: false,
        spinning: false,
    }

    onFinish = (value) => {
        this.setState({
            disabled: true,
            spinning: true,
        })

        const { geneid } = value

        const GeneEqtlVisualizer = window.GeneEqtlVisualizer
        
        let svgConfig = {
            id: 'bmap',
            width: window.innerWidth * 0.8,
            height: 650,
            marginTop: 20,
            marginRight: 20,
            marginBottom: 20,
            marginLeft: 100,
            legendHeight: 100, // assuming the color legends appear at the top of the focus panel

            miniPanelHeight: 100,

            focusPanelLabels: {
                column: {
                    show: true,
                    height: 100,
                    angle: 90,
                    adjust: 20,
                    location: 'bottom',
                    textAlign: 'left'
                },
                row: {
                    show: true,
                    width: 100,
                    angle: 0,
                    adjust: 30,
                    location: 'left',
                    textAlign: 'right'
                }
            },

            ldId: "ldMap",
            ldCutoff: 0.0,
            ldColorScheme: "Greys",
            ldLegendSpace: 50,

            colorScheme: "RdBu",
            colorScaleDomain: [-15, 15],

            useLog: false,
            logBase: undefined,

            // div IDs
            divSpinner: "spinner",
            divDashboard: "bmap-dashboard",
            divInfo: "bmap-filter-info",
            divGeneInfo: "bmap-gene-info",
            divModal: 'bmap-modal'
        }

        GeneEqtlVisualizer.cotton_dev_render(svgConfig, geneid, ()=>this.setState({disabled: false, spinning: false}))
    }

    render () {
        const { disabled, spinning } = this.state

        return (
            <React.Fragment>
                <Paragraph>
                    Show genetics variations that are highly correlated with gene expression patterns (expression quantitative trait loci, or eQTLs).<br />
                    Currently, only the cis-variants (within 1 megabase up/downstream of the transcription start site) that passed the cut-off of Bonferroni correction were displayed.
                </Paragraph>
                <Form layout="inline" onFinish={this.onFinish}>
                    <Col span={6}>
                        <Form.Item name="ref" label="Select a reference" rules={[{ required: true }]}>
                            <Select allowClear>
                                <Option value="SL5.0">SL5.0</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={6} push={1}>
                        <Form.Item name="geneid" id="gene" label="Gene ID">
                            <Input placeholder="e.g. Sopim_BGV006775_03T001977.1" />
                        </Form.Item>
                    </Col>
                    <Col push={1}>
                        <Form.Item>
                            <Button type="primary" disabled={disabled} htmlType="submit" block>Search</Button>
                        </Form.Item>
                    </Col>
                </Form>   
                <div> 
                    <div id="bmap-info-box" className="col-xs-12 col-sm-10">
                        <div id="bmap-gene-info" style={{fontSize: '12px'}}>GTEx Gene-eQTL Visualizer (GEV) is for exploring genetic variations associated with tissue-specific gene expression. <br/></div>
                        <div id="bmap-filter-info"></div>
                    </div>
                    <div id="bmap-dashboard" className="row" style={{borderBottom: '2px solid #e2e2e2', borderTop: '1px solid #e2e2e2'}}></div>
                    <div id="bmap-root">
                        <div className="eqtlmap-spin"><Spin size="large" spinning={spinning} /></div>
                        <div id="messageBox" style={{color: '#CB181D'}}></div>
                        <div id="bmap"></div>
                        <div id="ldMap" style={{height: 800}}></div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default EQTLviz
